import App from '@/App.vue';
import NotFound from '@/components/NotFound.vue';
import TheLogin from '@/components/TheLogin.vue';
import TopNavBar from '@/components/TopNavBar.vue';
import TheCart from '@/components/TheCart.vue';
import TheProducts from '@/components/TheProducts.vue';
import OrderHistory from '@/components/OrderHistory.vue';

import Alerts from '@/components/utilities/Alerts.vue';

export default {
  App,
  NotFound,
  TheLogin,
  TopNavBar,
  TheCart,
  TheProducts,
  OrderHistory,

  Alerts
};
